import { ModalSpinner } from '@/components/atoms'
import { MODALS, TRANSACTION_STATUS } from '@/constants'
import { useModals } from '@/hooks'
import { CheckCircleIcon, WarningIcon } from '@chakra-ui/icons'
import { useCallback, useEffect, useRef, useState } from 'react'

export const useTransactionModal = () => {
  const [status, setStatus] = useState(null)
  const modalMetadata = useRef({})
  const { openModal: openNativeModal, closeModal: closeNativeModal } =
    useModals()

  const openModal = useCallback((newStatus) => {
    setStatus(newStatus)
  }, [])

  const closeModal = useCallback(() => {
    setStatus(null)
    closeNativeModal(MODALS.TRANSACTION)
  }, [closeNativeModal])

  useEffect(() => {
    switch (status) {
      case TRANSACTION_STATUS.IS_SUCCESS:
        modalMetadata.current.title = 'Success'
        modalMetadata.current.content = 'Your transaction was successful.'
        modalMetadata.current.icon = (
          <CheckCircleIcon boxSize={16} color={'green'} />
        )
        break
      case TRANSACTION_STATUS.IS_ERROR:
        modalMetadata.current.title = 'Error'
        modalMetadata.current.content =
          'There was an error processing your transaction.'
        modalMetadata.current.icon = <WarningIcon boxSize={16} color={'red'} />
        break
      case TRANSACTION_STATUS.IS_PENDING:
        modalMetadata.current.title = 'Confirm in wallet'
        modalMetadata.current.content =
          'Confirm the transaction in your wallet.'
        modalMetadata.current.icon = <ModalSpinner color={'primary.400'} />
        break
      case TRANSACTION_STATUS.IS_CONFIRMING:
        modalMetadata.current.title = 'Confirming transaction'
        modalMetadata.current.content =
          'Your transaction block is being confirmed.'
        modalMetadata.current.icon = <ModalSpinner color={'primary.400'} />
        break
      default:
        modalMetadata.current = {}
        break
    }
  }, [status])

  useEffect(() => {
    const { title, content, icon } = modalMetadata.current

    if (status && title && content && openNativeModal) {
      openNativeModal(MODALS.TRANSACTION, { title, content, icon })
    }
  }, [status, openNativeModal])

  useEffect(() => {
    if (!status) {
      return
    }

    let timeoutId
    if (status === TRANSACTION_STATUS.IS_SUCCESS) {
      timeoutId = setTimeout(() => {
        closeModal()
      }, 1500)
    }
    return () => {
      if (status !== TRANSACTION_STATUS.IS_SUCCESS) {
        clearTimeout(timeoutId)
      }
    }
  }, [status, closeModal])

  return { openModal, closeModal }
}
